import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { PropsWithChildren, useRef } from "react";

interface ImpersonationConfirmDialogProps extends PropsWithChildren {
  onConfirm: () => void;
}

export default function ImpersonationConfirmDialog({
  children,
  onConfirm,
}: ImpersonationConfirmDialogProps) {
  const { t } = useTranslation();
  const cancelButtonRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        className="w-4/5 max-w-xl"
        onOpenAutoFocus={(e) => {
          e.preventDefault();
          cancelButtonRef.current?.focus();
        }}
      >
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-100">
              <AlertTriangle className="h-5 w-5 text-yellow-600" />
            </div>
            <DialogTitle className="text-left">
              {t("users.impersonation.confirmTitle")}
            </DialogTitle>
          </div>
        </DialogHeader>
        <div className="py-2 text-sm text-gray-700 space-y-3">
          <p>{t("users.impersonation.confirmContent")}</p>
          <p className="font-semibold text-gray-900">
            {t("users.impersonation.confirmContentBold")}
          </p>
        </div>
        <DialogFooter className="gap-3">
          <DialogClose asChild>
            <Button type="button" onClick={onConfirm}>
              {t("users.impersonation.confirmYes")}
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button ref={cancelButtonRef} variant="secondary">
              {t("users.impersonation.confirmNo")}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
